module.exports = __webpack_public_path__ + "img/43.5f0e5021.png";